import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';


export default class Tab extends Component {
    static propTypes = {
        children: PropTypes.any
    };
    static defaultProps = {};

    render() {
        return (
            <div className="component-tab">
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Tab/index.js